import { Translation } from 'hooks/useTranslation/useTranslation';
import { FilterSection } from 'v2/components/SearchAndFilters/SearchAndFilters';
import { filterStateDefault } from './deviceGroupFilterConstants';
import { DeviceGroupsFilterState } from './deviceGroupFilterTypes';

interface Params {
  translation: Translation;
  filters: DeviceGroupsFilterState;
}

export const createDeviceGroupFilterSections = ({ translation, filters }: Params): FilterSection[] => {
  const { filterState, setFilterState } = filters;

  return [
    {
      id: 'device_groups',
      header: translation.device_groups,
      isClearDisabled: !Object.values(filterState).some(Boolean),
      onClear: () => setFilterState(filterStateDefault),
      items: [
        {
          key: 'noDevices',
          label: translation.no_devices,
          checked: filterState.noDevices,
          onChange: () => setFilterState((current) => ({ ...current, noDevices: !current.noDevices }))
        },
        {
          key: 'noUserGroups',
          label: translation.no_user_groups,
          checked: filterState.noUserGroups,
          onChange: () => setFilterState((current) => ({ ...current, noUserGroups: !current.noUserGroups }))
        }
      ]
    }
  ];
};
